// This import loads the firebase namespace along with all its type information.
import User from './user-model'

export async function load_users(): Promise<User[]> {
  throw 'Not implemented'
}

export async function delete_user(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_user(): Promise<User> {
  throw 'Not implemented'
}
